/**
 * The hCaptcha site key this BUILD renders its challenge with.
 *
 * Public by construction — it ships inside the JS bundle and only names which
 * challenge to draw; the secret half (`HCAPTCHA_SECRET`) lives on the edge and
 * is what `siteverify` actually trusts. So it belongs in a build arg / ConfigMap
 * and never in a Secret, exactly like `VITE_GLITCHTIP_DSN`.
 *
 * UNSET IS A SUPPORTED STATE, and it is the local + test default: with no key
 * the front door renders no widget and sends no `captchaToken`, which pairs with
 * the edge's `NullCaptchaVerifier` (selected whenever `HCAPTCHA_SECRET` is
 * unset). The two halves must be configured TOGETHER — a build with no site key
 * against an edge that has the secret is a locked front door, because
 * `HCaptchaVerifier.verify` returns false on an empty token.
 */

/** The build-time variable a deployment sets. */
export const HCAPTCHA_SITEKEY_VAR = 'VITE_HCAPTCHA_SITEKEY';

/**
 * Normalise a configured key: trim, and treat blank/non-string as unset. Pure —
 * the `import.meta.env` read is {@link captchaSitekey}'s job, so this is
 * unit-tested with no `import.meta`.
 */
export function resolveCaptchaSitekey(configured: unknown): string | null {
  if (typeof configured !== 'string') {
    return null;
  }
  const trimmed = configured.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/** The effective site key for this build, or `null` when the bot gate is off. */
export function captchaSitekey(): string | null {
  // STATIC member access, deliberately — never `import.meta.env[HCAPTCHA_SITEKEY_VAR]`.
  // Vite's documented contract is textual replacement of the full
  // `import.meta.env.VITE_*` expression. It happens to also inline the whole env
  // object today (verified: a canary key survives a production build through a
  // computed read), but relying on that makes a locked front door depend on an
  // undocumented build detail. The exported name above stays for the docs and
  // the deploy checklist.
  return resolveCaptchaSitekey(import.meta.env.VITE_HCAPTCHA_SITEKEY);
}
